import type {HTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

export function CardTitle({className, ...props}: HTMLAttributes<HTMLHeadingElement>) {
  return <h3 data-slot="card-title" className={cn('text-base font-semibold leading-none', className)} {...props} />
}
